
import React from 'react';
import { format } from 'date-fns';
import { CalendarIcon, Clock, Check, Mail } from 'lucide-react';
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BookingData } from '@/services/bookingService';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

interface BookingConfirmationProps {
  booking: BookingData;
  onDone: () => void;
}

const BookingConfirmation: React.FC<BookingConfirmationProps> = ({ booking, onDone }) => {
  return (
    <Card className="max-w-md mx-auto">
      <CardHeader className="pb-2">
        <div className="bg-primary/10 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <Check className="h-8 w-8 text-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-center text-foreground">Booking Confirmed!</h2>
        <p className="text-muted-foreground text-center">
          We're looking forward to speaking with you
        </p>
      </CardHeader>
      
      <CardContent className="space-y-4">
        <Alert>
          <AlertTitle className="text-foreground">Check your email</AlertTitle>
          <AlertDescription className="text-muted-foreground">
            We've sent a confirmation email to <strong className="text-foreground">{booking.email}</strong> with all the details.
          </AlertDescription>
        </Alert>
        
        <div className="space-y-3 mt-4">
          <div className="flex items-start space-x-3">
            <CalendarIcon className="h-5 w-5 mt-0.5 text-muted-foreground" />
            <div>
              <h3 className="font-medium text-foreground">Date</h3>
              <p className="text-muted-foreground">{format(booking.date, "EEEE, MMMM d, yyyy")}</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Clock className="h-5 w-5 mt-0.5 text-muted-foreground" />
            <div>
              <h3 className="font-medium text-foreground">Time</h3>
              <p className="text-muted-foreground">{booking.timeSlot}</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <Mail className="h-5 w-5 mt-0.5 text-muted-foreground" />
            <div>
              <h3 className="font-medium text-foreground">Confirmation</h3>
              <p className="text-muted-foreground">Sent to <span className="text-foreground">{booking.email}</span></p>
            </div>
          </div>
        </div>
      </CardContent>
      
      <CardFooter>
        <Button onClick={onDone} className="w-full">
          Done
        </Button>
      </CardFooter>
    </Card>
  );
};

export default BookingConfirmation;
